import { useEffect } from "react";

/**
 * Fires a GA4 `cta_click` event whenever any Thanks.io outbound link is clicked.
 * Reads utm_medium from the href so we know which section drove the click.
 */
export const useCtaTracker = () => {
  useEffect(() => {
    const handler = (e) => {
      const a = e.target.closest("a[href*='thanks.io']");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      let medium = "unknown";
      try {
        const u = new URL(href);
        medium = u.searchParams.get("utm_medium") || "unknown";
      } catch {}
      const testid = a.getAttribute("data-testid") || "";

      if (typeof window.gtag === "function") {
        window.gtag("event", "cta_click", {
          cta_id: testid,
          section: medium,
          destination: href,
          transport_type: "beacon",
        });
      }
    };
    document.addEventListener("click", handler, { capture: true });
    return () => document.removeEventListener("click", handler, { capture: true });
  }, []);
};

export default useCtaTracker;
